import React, { useMemo } from "react";
import { withRouter } from "react-router";
import { Table } from "../../../../../shared/Table/Table";
import { useDiscounts } from "./hooks/useDiscounts";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import Header from "../../../components/Header";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "discountsReport.info.title",
  rows: ["discountsReport.info.note"],
};

const AllDiscounts = ({ history, period, selectedClinic, apiPeriod }) => {
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useDiscounts(requestParams);

  const tableDataEmpty = !isLoading && !data?.reportData?.length;

  const tableData = data?.reportData.map(
    (data) => ({
      clinic: data.clinic_name,
      discountAmount: data.amount,
      clinicId: data.clinic_id,
    }),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Discounts"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getDiscounts()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            onRowClick={(row) => {
              history.push(
                `/refactor-business-insight/sales/discounts/${row.clinicId}`,
              );
              selectedClinic.update(
                clinics.find((c) => c.value === row.clinicId),
              );
            }}
            cols={[
              { data: "Clinic", accessor: "clinic" },
              { data: "Discount Amount", accessor: "discountAmount" },
            ]}
            data={tableData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {tableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(AllDiscounts);
